import { defineComponent as _defineComponent } from 'vue'
import { computed, AsyncComponent } from 'vue';

interface Props {
  icon: string;
  containerSize?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'UiIcon',
  props: {
    icon: null,
    containerSize: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  icon: string;
  containerSize?: boolean;
};

const components: Record<string, AsyncComponent> = {
  searchIcon: () => import('@/components/icons/UiIconSearch.vue'),
  userIcon: () => import('@/components/icons/UiIconUser.vue'),
  menubarIcon: () => import('@/components/icons/UiIconMenuBar.vue'),
  closeIcon: () => import('@/components/icons/UiIconClose.vue'),
  closeBoldIcon: () => import('@/components/icons/UiIconCloseBold.vue'),
  arrowRightIcon: () => import('@/components/icons/UiIconArrowRight.vue'),
  arrowUpIcon: () => import('@/components/icons/UiIconArrowUp.vue'),
  arrowRightBoldIcon: () =>
    import('@/components/icons/UiIconArrowRightBold.vue'),
  sliderArrowLeftIcon: () =>
    import('@/components/icons/UiIconSliderArrowLeft.vue'),
  sliderArrowRightIcon: () =>
    import('@/components/icons/UiIconSliderArrowRight.vue'),
  chevronUpIcon: () => import('@/components/icons/UiIconChevronUp.vue'),
  chevronDownIcon: () => import('@/components/icons/UiIconChevronDown.vue'),
  chevronUpBigIcon: () => import('@/components/icons/UiIconChevronUpBig.vue'),
  chevronDownBigIcon: () =>
    import('@/components/icons/UiIconChevronDownBig.vue'),
  chevronRightIcon: () => import('@/components/icons/UiIconChevronRight.vue'),
  chevronLeftIcon: () => import('@/components/icons/UiIconChevronLeft.vue'),
  chevronRightThinIcon: () =>
    import('@/components/icons/UiIconChevronRightThin.vue'),
  instagramIcon: () => import('@/components/icons/UiIconInstagram.vue'),
  facebookIcon: () => import('@/components/icons/UiIconFacebook.vue'),
  twitterIcon: () => import('@/components/icons/UiIconTwitter.vue'),
  telegramIcon: () => import('@/components/icons/UiIconTelegram.vue'),
  youtubeIcon: () => import('@/components/icons/UiIconYoutube.vue'),
  linkedinIcon: () => import('@/components/icons/UiIconLinkedIn.vue'),
  logoMainIcon: () => import('@/components/icons/UiIconLogoMain.vue'),
  playIcon: () => import('@/components/icons/UiIconPlay.vue'),
  checkmarkIcon: () => import('@/components/icons/UiIconCheckmark.vue'),
  copyIcon: () => import('@/components/icons/UiIconCopy.vue'),
  quoteIcon: () => import('@/components/icons/UiIconQuote.vue'),
  pdfFileIcon: () => import('@/components/icons/UiIconPdfFile.vue'),
  downloadIcon: () => import('@/components/icons/UiIconDownload.vue'),
  filterIcon: () => import('@/components/icons/UiIconFilter.vue'),
  warningIcon: () => import('@/components/icons/UiIconWarning.vue'),
  locationIcon: () => import('@/components/icons/UiIconLocation.vue'),
  aClassIcon: () => import('@/components/icons/UiIconAClass.vue'),
  bClassIcon: () => import('@/components/icons/UiIconBClass.vue'),
  cClassIcon: () => import('@/components/icons/UiIconCClass.vue'),
  dClassIcon: () => import('@/components/icons/UiIconDClass.vue'),
  eClassIcon: () => import('@/components/icons/UiIconEClass.vue'),
  fClassIcon: () => import('@/components/icons/UiIconFClass.vue'),
  gClassIcon: () => import('@/components/icons/UiIconGClass.vue'),
};



const iconComponent = computed<AsyncComponent>(
  () => components[`${props.icon}Icon`],
);

return { __sfc: true,components, props, iconComponent }
}

})